/**
 * 阅后即焚选择器懒加载壳（21ag；EncryptionDialogsLazy 同构）。
 * 加载期间什么都不渲染——点击与弹层之间差一个动态 import 的往返（本地块）。
 */
import { useLazyModule } from './useLazyModule';

export function AfterViewSheetLazy(props: {
  anchor: { top: number; right: number };
  seconds: number;
  mobile: boolean;
  onClose: () => void;
  onPick: (next: number) => void;
}) {
  const { mod } = useLazyModule(() => import('./AfterViewSheet'));
  if (mod === null) return null;
  return <mod.AfterViewSheet {...props} />;
}
